<template>
  <v-row>
    <v-col cols="12">
      <v-data-table :headers="headers" :items="items" :options.sync="options" :server-items-length="totalItems"
        :loading="loading" loading-text="Cargando..." class="elevation-1" :expanded.sync="expanded" item-key="id"
        :footer-props="footerOptions" single-expand>
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>{{ title }}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-select v-model="periodosFilter" :items="periodosOptions" label="Periodos" dense hide-details
              style="max-width: 220px;" @change="onChangePeriodos" />
          </v-toolbar>
        </template>
        <template v-slot:no-data>
          <v-label>No se encontraron resultados.</v-label>
          <br />
          <v-btn :color="themeColor" @click="reset">Restablecer filtro</v-btn>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('enterprises') };
  },
  props: {
    id: { default: '' },
    action: { default: '' },
    queryParams: {
      type: String,
      required: false,
      default: '',
    },
  },
  data: () => ({
    expanded: [],
    loading: false,
    editedIndex: -1,
    options: {},
    periodosFilter: 1,
    periodosOptions: [
      { value: 1, text: 'Último periodo' },
      { value: 2, text: 'Últimos tres periodos' },
      { value: 3, text: 'Últimos seis periodos' },
      { value: 4, text: 'Últimos doce periodos' },
    ],
    items: [],
    totalItems: 0,
    footerOptions: { 'items-per-page-options': [-1] },
    headers: [
      {
        text: 'Fecha de corte',
        value: 'fecha_corte',
        sortable: true,
      },
      {
        text: 'Periodo',
        value: 'periodo',
      },
      {
        text: 'Consumo de folios',
        value: 'total_folios',
      },
    ],
  }),
  computed: {
    apiURL() {
      return `/api/enterprises/${this.id}/reporte-consumo`;
    },
    title() {
      return 'Reporte de Consumo';
    },
    ...mapGetters({
      user: 'auth/user',
      themeColor: 'theme/themeColor',
    }),
  },

  watch: {
    options: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
    apiURL: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
    queryParams: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
  },

  mounted() {
    const url = `/api/enterprises/${this.id}/licence/showLicence`;
    window.axios.get(url)
      .then((response) => {
        this.services = response.data.items;
      });
    window.axios.get(`/api/enterprises/${this.id}`).then((result) => {
      this.name = result.data.name;
    });
  },

  methods: {
    onChangePeriodos() {
      this.loading = true;
      this.items = [];
      this.refreshTable();
    },
    refreshTable() {
      this.loading = true;
      this.getDataFromApi().then((data) => {
        this.items = data.items;
        this.totalItems = data.total;
        this.loading = false;
      });
    },
    getDataFromApi() {
      return new Promise(async (resolve) => {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;
        const response = await this.getItems(
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
        ).then((result) => {
          // El backend retorna directamente un arreglo JSON
          const data = Array.isArray(result.data) ? result.data : [];
          const total = data.length;
          return { data, total };
        });
        const items = response.data;
        const { total } = response;
        resolve({
          items,
          total,
        });
      });
    },
    getItems(page, itemsPerPage, sortBy, sortDesc) {
      const url = `${this.apiURL}?currentPage=${page}&perPage=${itemsPerPage}
        &periodos=${this.periodosFilter}&sortBy=${sortBy}&desc=${sortDesc}${this.queryParams}`;
      const promise = window.axios.get(url).then();
      return promise;
    },
    openModalDelete(item) {
      this.dialog = true;
      this.item = item;
    },
    reset() {
      this.periodosFilter = 1;
    },
  },
};
</script>
